import React from 'react'
import Helmet from 'react-helmet'
import get from 'lodash/get'
import Layout from '../components/layout'

class JobBoardGuidelinesPage extends React.Component {
  render() {
    const siteTitle = get(this, 'props.data.site.siteMetadata.title')
    const color = 'rgb(211, 232, 225)'
    const category = 'Job Board Guidelines'
    const description = ''

    return (
      <Layout location={this.props.location} style={{ backgroundColor: color }}>
        <Helmet
          htmlAttributes={{ lang: 'en' }}
          meta={[
            { name: 'description', content: description },
            { property: 'og:title', content: category },
            {
              property: 'og:description',
              content: description,
            },
            {
              property: 'twitter:title',
              content: category,
            },
            {
              property: 'twitter:description',
              content: description,
            },
          ]}
          title={siteTitle}
        />

        <div
          className="p-6"
          style={{ backgroundColor: color, maxWidth: '100%' }}
        >
          <h1>{category}</h1>
          <p className="text-xl">{description}</p>
          <br />
          <br />
          <a
            href="/post-a-job"
            rel="noopener noreferrer"
            className="text-black"
          >
            <div>Post a Job →</div>
          </a>
        </div>

        <div className="max-w-screen-md p-6 pb-2 m-6 mx-auto text-lg leading-normal bg-white border rounded border-light-grey ">
          <h2>Hello!</h2>
          <br />
          <p>
            Thank you for considering Diversify Tech's job board. We want to
            make sure that we are the right fit for each other.
          </p>
          <h3>On the type of roles that work best</h3>
          <ul>
            <li>Developer, Designer, Data, Product and IT roles work best.</li>
            <li>
              Our community is a mix of entry-level to senior level people.
              Please post a mix of those. When you post only senior level roles
              it feels like you are setting the bar high for underrepresented
              folks in tech.
            </li>
            <li>
              CTO, VP, Director and other high level roles are not the best fit
              for our community. You are welcome to post them but please don't
              expect many applicants.
            </li>
            <li>
              Unpaid positions are not inclusive. Please post only paid
              positions.
            </li>
          </ul>

          <h3>Location</h3>
          <ul>
            <li>
              Our members are primarily in North America (United States &
              Canada) and Europe. Please post either remote or North America and
              Europe roles.
            </li>
          </ul>

          <h3>Interview</h3>
          <ul>
            <li>
              <a href="https://news.ncsu.edu/2020/07/tech-job-interviews-anxiety/">
                Whiteboard/live coding interviews
              </a>{' '}
              assess anxiety not coding skills. If you do whiteboard
              interviewing, we are not the right fit for you.
            </li>
          </ul>

          <h3>Company values</h3>
          <ul>
            <li>
              You will give our members a fair chance. If you already have
              someone else in mind for your role, we are not the right fit.
            </li>
            <li>
              You will pay competitive salaries. We are not the right place if
              you are looking for "cheap" labor.
            </li>
            <li>Your company provides work-life balance.</li>
            <li>
              You don't work with or support entities that support war, commit
              human rights violations or worsen climate change.
            </li>
            <li>
              We check employee reviews (Glassdoor, Indeed, InHerSight, tech
              communities). If the reviews in the past year mention issues
              around diversity, management or pay issues, we'll have to decline.
            </li>
          </ul>

          <h3>Timeline</h3>
          <ul>
            <li>
              Please post at least 2 weeks before the application deadline. Our
              newsletter is weekly and we want to make sure that we have enough
              time to promote your roles.
            </li>
            <li>
              Once you share your roles, we will review and add them to our job
              board within 1-2 business days. If they don't meet our guidelines,
              we'll decline and won't charge you the fees.
            </li>
          </ul>

          <p>
            Finally, please treat our members well. Remember that they are
            interviewing you as much you are interviewing them.
          </p>

          {/* <h2>Questions?</h2>
          <p>Please <a href="/contact">reach out to us</a>!</p>
          <br /> */}

          <p>
            <a
              href="/post-a-job"
              className="inline-block px-4 py-2 mt-4 text-sm text-white no-underline bg-black rounded hover:bg-grey-dark lg:mt-0"
            >
              Post a Job
            </a>
          </p>
        </div>
      </Layout>
    )
  }
}

export default JobBoardGuidelinesPage
